import { makeStyles } from '@material-ui/core';
import { MDSDivider, MDSTypography } from '@marqvision/mds-v2';
import { AuthProtocolsGetUserInfoResponse, SettingsProtocolsGetProfileResponse } from '~/swagger/data-contracts';
import { attachPmmS3BaseUrl } from '../@utils';

const useStyles = makeStyles({
  layout: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  space: {
    width: '100%',
    height: '8px',
  },
  paragraph: {
    // padding: '8px 0',
  },
  link: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  item: {
    display: 'flex',
    '& > p': {
      marginLeft: '8px',
      width: '24px',
    },
    '& > p:last-child': {
      flex: 1,
      marginLeft: '-12px',
    },
  },
  video: {
    borderRadius: '8px',
    backgroundColor: '#000',
    width: '640px',
    height: '391px',
    overflow: 'hidden',
  },
  actions: {
    padding: '16px 20px',
    display: 'flex',
    justifyContent: 'space-between',
  },
});
type Props = {
  userInfo: AuthProtocolsGetUserInfoResponse;
  userProfile: SettingsProtocolsGetProfileResponse;
};
export const ContentKR = (props: Props) => {
  const classes = useStyles();
  const { userInfo, userProfile } = props;

  return (
    <div className={classes.layout}>
      <MDSTypography variant="T20" weight="bold">
        Marq AI: Your New, Unified Dashboard
      </MDSTypography>

      <div style={{ padding: '8px 0' }}>
        <MDSDivider orientation="horizontal" />
      </div>

      <div className={classes.list}>
        <div className={classes.paragraph}>
          <MDSTypography variant="T14">
            안녕하세요, {userProfile.first_name} {userProfile.last_name}님,
          </MDSTypography>
        </div>
        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            새롭고 향상된 Marq AI 대시보드에 오신 것을 환영합니다. 여기에서는 이전 Marq Content 대시보드의 기능들이
            통합되어 있음을 확인하실 수 있습니다.
          </MDSTypography>
        </div>

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography variant="T16" weight="medium">
            Channel-based Dashboard
          </MDSTypography>
        </div>
        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            가장 큰 업데이트는 새롭게 디자인된 대시보드입니다. 이제 모든 침해 리스팅들이 채널 별로 정리되어 별도의
            페이지로 구성되었습니다. 웹사이트 콘텐츠, 소셜 미디어, 마켓플레이스를 포함한 모든 침해 의심 링크 및 게시물을
            한 곳에서 확인할 수 있으며, 각 페이지 내에서 탐지, 제재, 제거에 이르는 여정을 확인할 수 있습니다.
          </MDSTypography>
        </div>
        <img src={attachPmmS3BaseUrl('250107-pmm-channel-based-dashboard.png')} alt="review-needed" />

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography variant="T16" weight="medium">
            The New ‘Home’ Tab
          </MDSTypography>
        </div>
        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            새로운 Home 탭에서는 진행 중인 작업을 한눈에 확인하고, 새로운 요청(신고, 철회, 화이트리스트 추가, Asset
            변경)을 제출하며, 고객 성공 매니저가 공유하는 성과 리뷰 인사이트에 접근할 수 있습니다.
          </MDSTypography>
        </div>
        <img src={attachPmmS3BaseUrl('250107-pmm-the-new-home-tab.png')} alt="smart-rules" />

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography wordBreak="keep-all" variant="T14">
            고객님의 피드백은 마크비전의 성장과 발전에 중요한 발판이 됩니다. 관련한 피드백 또는 문의가 있으시다면
            언제든지 담당 CSM에게 문의해주세요.
          </MDSTypography>
        </div>

        <div className={classes.space} />

        <div className={classes.paragraph}>
          <MDSTypography as="span" wordBreak="keep-all" variant="T14">
            당신의 의견을 공유하고 싶으신가요?
          </MDSTypography>{' '}
          <MDSTypography
            color="color/content/primary/default/normal"
            as="a"
            href={'https://forms.gle/ZQhf6fXnejymRui4A'}
            target="_blank"
            wordBreak="keep-all"
            variant="T14"
          >
            1분 만에 완료할 수 있는 간단한 설문조사에 참여해 주세요!
          </MDSTypography>
        </div>
      </div>
    </div>
  );
};
